'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LAYOUT_TYPES = exports.LAYOUT_CLASSES = exports.CARD_BACKGROUND = undefined;

var _theme = require('HubStyleTokens/theme');

var CARD_BACKGROUND = exports.CARD_BACKGROUND = _theme.BASE_BACKGROUND_COLOR_MEDIUM;

var LAYOUT_CLASSES = exports.LAYOUT_CLASSES = {
  'full-width': 'private-template--full-width',
  'max-width': 'private-template--centered'
};

var LAYOUT_TYPES = exports.LAYOUT_TYPES = ['flex', 'grid'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/page/PageConstants.js
// module id = 180
// module chunks = 0